/* eslint-disable no-confusing-arrow */
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import useGetQueryString from 'src/shared/hooks/useGetQueryString';
import styled from 'styled-components';
import { VIEW_MODES } from 'src/components/BookSearch/Constants';
import OlogyBookFilter from '../SchoolGradeOlogy/OlogyBooks/OlogyBookFilter';
import BookList from '../BookSearch/BookList';
import {
  getBooksBySearchAll,
  PAGE_SIZE
} from './BookSearchByTypeApi';

const Wrapper = styled.div`
  display: flex;
  padding-top: 20px;
`;

const BookListWrapper = styled.div`
  flex: 1;
`;

const MenuWrapper = styled.div``;

const Message = styled.h3`
  padding: 10px;
`;

const Title = styled.div`
  padding: 8px 20px;
  font-size: 14px;
  position: relative;
  margin: 0 20px 8px 20px;
  background-color: var(--title-backgournd-grey);

  &::before {
    position: absolute;
    top: 100%;
    content: '';
    height: 2px;
    width: 100px;
    background: var(--main-web-color);
    display: block;
  }
`;

const TitleOlogy = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: var(--title-backgournd-grey);
`;

const TitleIconWrapper = styled.div`
  height: 40px;
  width: 35px;
  background-color: var(--main-web-color);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

const TitleText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const OlogyTitleText = styled(TitleText)`
  max-width: 215px;
`;

const CurriculumTitleText = styled(TitleText)`
  max-width: 500px;
`;

const CustomOlogyBookFilter = styled(OlogyBookFilter)`
  margin-top: 16px;
`;

const GET_BY_TYPE = {
  ology: 'ology',
  group: 'group',
  type: 'type',
  content: 'content',
  searchAll: 'searchAll',
  other: 'other',
};

function BookSerchByType({ bookKind = BOOK_KIND.book }) {
  const { Searchkey } = useGetQueryString();
  const [width, setWidth] = useState();
  const [resetFilter, setResetFilter] = useState({});
  const [isBooksLoading, setIsBooksLoading] = useState(false);
  const [bookList, setBookList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalBooks, setTotalBooks] = useState(0);
  const [infoMessage, setInfoMessage] = useState('');

  const wrapperRef = useRef(null);
  const currentSelectedItem = useRef();
  const currentSearchValue = useRef();

  useLayoutEffect(() => {
    setWidth(wrapperRef.current?.offsetWidth);
  }, []);

  const setBookContent = useCallback((data) => {
    setIsBooksLoading(false);

    if (!data.length || !data[0].Success) {
      setTotalBooks(0);
      setBookList([]);
      if (data[0]?.Message) {
        setInfoMessage(data[0].Message);
      }
      return;
    }

    setBookList(data);
    setTotalBooks(data[0].TotalRecords);
  }, []);

  const getBookList = useCallback(
    ({ page, searchValue = currentSearchValue.current }) => {
      setInfoMessage('');
      setIsBooksLoading(true);
      getBooksBySearchAll({
        page,
        searchValue,
        bookKind,
      }).then((data) => {
        setBookContent(data);
      });
    },
    [currentSelectedItem.current]
  );

  useEffect(() => {
    getBookList({
      searchValue: Searchkey
    });
  }, []);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      getBookList({ page });
    },
    [getBookList, setCurrentPage]
  );

  const handleFilterChange = useCallback(
    ({ searchValue, bookType }) => {
      setCurrentPage(1);
      currentSearchValue.current = searchValue;
      getBookList({
        page: currentPage,
        searchValue: currentSearchValue.current
      });
    },
    [getBookList]
  );

  return (
    <Wrapper
      ref={wrapperRef}
      className="flex-col gap-[20px] sm:flex-row sm:gap-[4px]"
    >
      <BookListWrapper>
        <Title>
          <CurriculumTitleText>Tìm tài liệu</CurriculumTitleText>
        </Title>
        <CustomOlogyBookFilter
          onFilter={handleFilterChange}
          resetFilter={resetFilter}
          shouldFilterByBookType={false}
          initialSearchKey={Searchkey || ''}
        />
        {infoMessage ? (
          <Message>{infoMessage}</Message>
        ) : (
          <BookList
            bookList={bookList}
            isLoading={isBooksLoading}
            total={totalBooks}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            pageSize={PAGE_SIZE}
            initialViewMode={VIEW_MODES.grid}
            shouldShowViewMode
          />
        )}
      </BookListWrapper>
    </Wrapper>
  );
}

export default BookSerchByType;
